export type IdTour = string;

export type PosicionTour =
  | "arriba"
  | "abajo"
  | "izquierda"
  | "derecha"
  | "centro";

/** @deprecated Usa {@link PosicionTour}. Se mantiene como alias por compatibilidad. */
export type PosicionPasoTour = PosicionTour;

/**
 * Una acotación es cada línea de apoyo bajo la descripción.
 *
 *  "paso" → forma parte de la secuencia y se numera (01, 02, …).
 *  "nota" → información complementaria; sale de la numeración y va al
 *           banner con "i". Numerar implica que todas pesan igual y son
 *           parte de una secuencia; una restricción del sistema no lo es.
 *
 * `campo` es el sujeto de la frase, extraído fuera del texto. Permite
 * escanear por etiqueta y acorta la redacción:
 *
 *   antes → "La serie se propone según el tipo de comprobante, pero puedes cambiarla."
 *   ahora → campo: "Serie", texto: "Se propone según el tipo de comprobante, pero puedes cambiarla."
 */
export interface AcotacionTour {
  tipo: "paso" | "nota";
  campo: string;
  texto: string;
}

export interface PasoTour {
  idPaso: string;
  selector: string;
  titulo: string;
  descripcion: string;
  /**
   * Nombre de la sección para la pestaña anclada al recorte.
   * Si se omite no se dibuja la pestaña.
   */
  seccion?: string;
  posicion?: PosicionTour;
  selectorExpandido?: string;
  /** Margen del recuadro de resaltado alrededor del elemento, en px. @default 10 */
  margenResaltado?: number;
  /** Líneas de apoyo, separadas en secuencia y notas. */
  acotaciones?: AcotacionTour[];
  /**
   * @deprecated Usa {@link acotaciones}. Se mantiene por compatibilidad con
   * los pasos ya escritos; se renderiza como acotaciones de tipo "paso" sin
   * etiqueta de campo (ver {@link normalizarAcotaciones}).
   */
  contenidoLectura?: string[];
}

/** Normaliza el formato antiguo (`contenidoLectura`) al nuevo (`acotaciones`) sin romper nada. */
export function normalizarAcotaciones(paso: PasoTour | null): AcotacionTour[] {
  if (!paso) return [];
  if (paso.acotaciones?.length) return paso.acotaciones;
  if (paso.contenidoLectura?.length) {
    return paso.contenidoLectura
      .map((texto) => texto.trim())
      .filter(Boolean)
      .map((texto) => ({ tipo: "paso" as const, campo: "", texto }));
  }
  return [];
}

export interface DefinicionTour {
  id: IdTour;
  version: number;
  pasos: PasoTour[];
}

export interface EstadoAyudaGuiada {
  ayudaActivada: boolean;
  toursCompletados: IdTour[];
  toursOmitidos: IdTour[];
  versionPorTour: Record<IdTour, number>;
  fechaUltimaActualizacion: string;
}
